import { render } from "./Offer.vue?vue&type=template&id=1dbb2560&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"

import "./Offer.vue?vue&type=style&index=0&id=1dbb2560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbb2560"]])

export default __exports__